import buildMeta from '../utils/buildMeta'

const routes = [
  {
    name: 'history',
    path: '/history',
    component: () => import('@/pages/History/Home.vue'),
    meta: buildMeta({
      authRequired: true,
      robots: 'noindex',
      title: 'History - Jobscan',
      description: 'Review activity history.',
    }),
    children: [
      {
        name: 'tracker-history',
        path: 'tracker',
        component: () => import('@/pages/History/components/Tracker.vue'),
        meta: buildMeta({
          authRequired: true,
          robots: 'noindex',
        }),
      },
    ],
  },
]

export default routes
